// @flow

type Options = {|
    currency: string | false,
    decimal: number,
    separator: string
|};

const DEFAULT_OPTIONS: Options = {
    currency  : 'CHF',
    decimal   : 2,
    separator : '\''
};

const _normalizeAmount = (amount: string | number): number | null => {
    if (!['number', 'string'].includes(typeof amount) || amount === '') {
        return null;
    }
    const _amount = Number(amount);

    if (Number.isNaN(_amount) || !Number.isFinite(_amount)) {
        return null;
    }

    return _amount;
};

const formatAmount = (amount: string | number, options: $Shape<Options> = {}): string => {
    const _amount = _normalizeAmount(amount);
    if (_amount === null) {
        throw new Error(`"${amount}" is not a valid amount.`);
    }

    // @see https://github.com/facebook/flow/issues/2405
    // flow-disable-next-line
    const _options: Options = { ...DEFAULT_OPTIONS, ...options };

    const formatted = _amount
        .toFixed(_options.decimal ?? 0)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, _options.separator);
    if (!_options.currency) {
        return formatted;
    }

    return `${_options.currency} ${formatted}`;
};

export default formatAmount;
